export default __webpack_public_path__ + "static/media/cuestionario.efac981e.png";